export default "__VITE_ASSET__YiuJdInZ__";